<template>
<w-settings-content-template>
  <el-row slot="content">
    <el-row class="title-bar" type="flex" justify="space-between">
      <span class="title-h3">운영 포트 설정</span>
      <div class="vertical-center-box">
        <el-button class="mr-r4" type="primary" @click="saveOprationSetting" :disabled="!changeFlag">저장</el-button>
        <el-button @click="cancelOperationSetting" :disabled="!changeFlag">취소</el-button>
      </div>
    </el-row>
    <hr class="mr-b20">
    <el-row class="list form-list">
      <el-col :span="12">
        <el-form ref="summaryForm" :model="formData" label-position="left" label-width="200px">
          <el-form-item label="SNMP Trap 수집포트" prop="SNMPTRAP_PORT">
            <el-input @change="checkChangeFlag('SNMPTRAP_PORT')" v-model="formData.SNMPTRAP_PORT"/>
          </el-form-item>
          <el-form-item label="Syslog 수집포트" prop="SYSLOG_SOCKET_PORT">
            <el-input @change="checkChangeFlag('SYSLOG_SOCKET_PORT')" v-model="formData.SYSLOG_SOCKET_PORT"/>
          </el-form-item>
          <el-form-item label="어플리케이션로그 수집포트" prop="SYSLOG_SOCKET_PORT">
            <el-input @change="checkChangeFlag('APPLOG_SOCKET_PORT')" v-model="formData.APPLOG_SOCKET_PORT"/>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </el-row>
</w-settings-content-template>
</template>

<script>
import WSettingsContentTemplate from '@/components/template/SettingsContentTemplate';
import basicinfoSetAPI from '@/api/model/basicinfo-set';
import OperationSettingsAPI from '@/api/settings/common/operation-settings';
import msgUtil from '@/utils/message';
import { forEach, cloneDeep, isEqual, isNaN, toNumber } from 'lodash';

export default {
  name: 'WOperationPort',
  components: {
    WSettingsContentTemplate,
  },
  data() {
    return {
      formData: {},
      formOriginData: {},
      changeFlag: false,
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      basicinfoSetAPI.getList('EMSCONFIG').then((response) => {
        if (response.data.success) {
          this.formData = this.convertToPolicyObj(response.data.data);
          this.formOriginData = cloneDeep(this.formData);
        }
      });
    },
    // basicinfo_set 정책 조회
    convertToPolicyObj(policyList) {
      const policyObj = {};
      forEach(policyList, (policy) => {
        if (policy.datatypeId === 'BOOL') {
          policyObj[policy.basicinfoSubid] = policy.basicinfoSubvalueBoolean;
        } else if (policy.datatypeId === 'INTEGER') {
          policyObj[policy.basicinfoSubid] = policy.basicinfoSubvalueInteger;
        } else if (policy.datatypeId === 'STRING') {
          policyObj[policy.basicinfoSubid] = policy.basicinfoSubvalueString;
        }
      });
      return policyObj;
    },
    saveOprationSetting() {
      const params = [];

      forEach(this.formData, (value, key) => {
        const paramObject = {
          basicinfoId: 'EMSCONFIG',
        };
        if (key === 'SNMPTRAP_PORT') {
          paramObject.basicinfoSubid = key;
          paramObject.basicinfoSubvalueInteger = value;
          params.push(paramObject);
        } else if (key === 'SYSLOG_SOCKET_PORT') {
          paramObject.basicinfoSubid = key;
          paramObject.basicinfoSubvalueInteger = value;
          params.push(paramObject);
        } else if (key === 'APPLOG_SOCKET_PORT') {
          paramObject.basicinfoSubid = key;
          paramObject.basicinfoSubvalueInteger = value;
          params.push(paramObject);
        }
      });
      const target = '수집 포트 설정';
      const action = msgUtil.action.SAVE;
      OperationSettingsAPI.setOperationPort(params)
        .then((response) => {
          if (response.data.success) {
            this.$message(msgUtil.getResultMsgData(action, target, true));
            this.loadData();
          } else {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          }
        })
        .catch(() => {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        });
    },
    // reset Data
    cancelOperationSetting() {
      this.formData = cloneDeep(this.formOriginData);
      this.changeFlag = !isEqual(this.formData, this.formOriginData);
    },
    checkChangeFlag(target) {
      if (!isNaN(toNumber(this.formData[target]))) {
        this.formData[target] = toNumber(this.formData[target]);
      } else {
        this.formData[target] = cloneDeep(this.formOriginData[target]);
      }
      this.changeFlag = !isEqual(this.formData, this.formOriginData);
    },
  },
};
</script>

<style>
.operation-title {
  padding: 30px 0px 20px 0px;
}
</style>



// WEBPACK FOOTER //
// src/views/settings/operation/CollectionSettings/OperationPort/index.vue